var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('vue-horizontal-list',{attrs:{"items":_vm.items,"options":_vm.options},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('div',[_c('div',{staticClass:"image-container"},[_c('img',{staticClass:"img-fluid",attrs:{"src":item.image}})])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }